<template>
  <v-container fluid>
    <BaseTable
        title="Customers"
        :subtractHeight="subtractHeight"
        :height="height"
        :dto-model="dto_model"
        dto-save-list-model="CustomerSaveListCommandDTO"
        store-name="CustomerTable"
        new-item-component="CustomerItem"
        new-item-pass="/Product/Customer/CustomerItem"
        :lang-dictionary="function(text) {return $t(text)}"
        fixed-header
        show-selected
        :single-select="false"
        :filters-init="[{param_compare: 'is_provider', value: false}]"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
                v-if="item.notion_id != null"
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
      </template>
      <template v-slot:item.name="{ item }">
        <router-link :to="{name:'CustomerItem', params: { itemUid: item.uid}}">
          {{item.name}}
        </router-link>
      </template>
    </BaseTable>
  </v-container>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import CustomerItem from "@/components/Product/Customer/CustomerItem";

export default {
  name: 'CustomerTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    dto_convert_to_provider: {type: [String], default: 'CustomerConvertToProviderCommandDTO'},
    dto_update_from_notion: {type: [String], default: 'CustomerUpdateFromNotionCommandDTO'},
    dto_model: {type: [String], default: 'CustomerListQueryDTO'},
  },

  components: {
    BaseTable,
    CustomerItem,
  },

  computed: {},

  methods: {
    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    updateFromNotion(instance) {
      console.log('updateFromNotion', instance)
      let dto_action = {
        current_uid: null,
        selected_uid_list: [],
      }
      instance.fetchAction({dto: dto_action, dto_action_model: this.dto_update_from_notion})
      instance.fetchItemList(this.dto_model)
    },
    convertToProvider(instance) {
      console.log('convertToProvider', instance)
      let selected_uid_list = []
      instance.selectedItemList.forEach(row => selected_uid_list.push(row.uid))
      let dto_action = {
        current_uid: null,
        selected_uid_list: selected_uid_list,
      }
      instance.selectedItemList = []
      instance.fetchAction({dto: dto_action, dto_action_model: this.dto_convert_to_provider})
      instance.fetchItemList('CustomerListQueryDTO')
    },
  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      informationDialog: false,
      information: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
    "en": {
    "search": "Search",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "notion_id": "N",
      "name": "Name",
      "alias": "Alias",
      "address": "Address",
      "phones": "Phones",
      "url": "URL",
      "note": "Note",
      "cache_time": "Cache time (h)",
      "priority": "Priority",
      "scrap_enable": "Scrap enable",
      "background_color": "Color",
      "created_by": "Created by",
      "created_by_name": "Created by",
      "created_on": "Created on",
      "edited_by": "Edited by",
      "edited_by_name": "Edited by",
      "edited_on": "Edited on"
    },
    "Save": "Save",
    "Cancel": "Cancel",
    "new_item": "New customer"
  },
  "de": {
    "search": "Suche",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "notion_id": "N",
      "name": "Name",
      "alias": "Alias",
      "address": "Address",
      "phones": "Phones",
      "url": "URL",
      "note": "Note",
      "cache_time": "Cache time (h)",
      "priority": "Priority",
      "scrap_enable": "Scrap enable",
      "background_color": "Color",
      "created_by_name": "Erstellt von",
      "created_on": "Erstellt am",
      "edited_by": "Bearbeitet von",
      "edited_by_name": "Bearbeitet von",
      "edited_on": "Bearbeitet am"
    },
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "new_item": "Neuer Kunde"
  }
}
</i18n>
